<template>
  <div class="font-weight">基础</div>
  <el-radio-group class="mb-10" v-model="temData.type">
    <el-radio label="">不处理</el-radio>
    <el-radio label="number" name="数值">数值</el-radio>
    <el-radio label="percent" name="百分比（%）">百分比（%）</el-radio>
    <el-radio label="date" name="日期">日期</el-radio>
    <el-radio label="dict" name="字典">字典</el-radio>
  </el-radio-group>
  <template v-if="temData.type">
    <template v-if="temData.type === 'dict'">
      <form-item labelAlign="left" :label-width="90" class="mb-10" inline label="选择字典">
        <el-select filterable @change="getOptions($event)" v-model="temData.dictKey" size="small">
          <el-option v-for="item in dics" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </form-item>
      <form-item labelAlign="left" :label-width="90" class="mb-10" inline label="字典预览内容">
        <el-select size="small" v-model="view">
          <el-option v-for="item in dicOptions" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </form-item>
    </template>
    <form-item labelAlign="left" v-if="temData.type === 'number' || temData.type === 'percent'" label="小数位">
      <el-input-number v-model="temData.digits" />
    </form-item>
    <form-item labelAlign="left" v-if="temData.type === 'number'" label="千分位隔符（,）">
      <el-switch v-model="temData.splitMark" />
    </form-item>
    <form-item labelAlign="left" v-if="temData.type === 'number'" label="数量单位" :label-width="38">
      <el-tooltip effect="light" content="注：此处数量单位设置仅做计算使用，不显示单位文字，如果要显示单位文字，请在基础配置-单位中设置" placement="top">
        <el-icon class="fs-12 cursor">
          <QuestionFilled></QuestionFilled>
        </el-icon>
      </el-tooltip>
      <el-select v-model="temData.unit">
        <el-option value="1" label="无"></el-option>
        <el-option value="1000" label="千"></el-option>
        <el-option value="10000" label="万"></el-option>
        <el-option value="1000000" label="百万"></el-option>
        <el-option value="100000000" label="亿"></el-option>
        <el-option value="1000000000000" label="兆"></el-option>
      </el-select>
    </form-item>
    <form-item labelAlign="left" v-else-if="temData.type === 'date'" label="日期格式">
      <el-select v-model="temData.dateFormatType" @change="(v) => (temData.dateFormat = v)">
        <el-option value="YYYY-MM-DD" label="2008-08-08"></el-option>
        <el-option value="YYYY-MM" label="2008-08"></el-option>
        <el-option value="MM-DD" label="08-08"></el-option>
        <el-option value="YYYY" label="2008"></el-option>
        <el-option value="YYYY-MM-DD HH:mm:ss" label="2008-08-08 23:59:59"></el-option>
        <el-option value="" label="自定义"></el-option>
      </el-select>
      <div style="width: 16px;"></div>
      <el-input v-model="temData.dateFormat" :disabled="!!temData.dateFormatType"></el-input>
    </form-item>
  </template>
  <div class="font-weight mt-10 mb-10">空值替换</div>
  <div>
    <form-item labelAlign="left" label="替换前">
      <el-checkbox-group v-model="temData.nullList">
        <el-checkbox label="null">null</el-checkbox>
        <el-checkbox label="emptyString">空字符串（''）</el-checkbox>
        <el-checkbox label="0">0</el-checkbox>
        <el-checkbox label="NaN">NaN</el-checkbox>
        <el-checkbox label="Infinity">Infinity</el-checkbox>
        <el-checkbox label="undefined">undefined</el-checkbox>
      </el-checkbox-group>
    </form-item>
    <form-item labelAlign="left" label="替换后">
      <el-input style="width: 150px" v-model="temData.nullValue"></el-input>
    </form-item>
  </div>
</template>
<script setup>
import { commonDao, bizPath, dictItemDao } from "@/option/common/dao";
import { QuestionFilled } from "@element-plus/icons-vue";
import { ref } from "vue";

let props = defineProps({
  temData: {},
});
let dics = ref([]);
let dicOptions = ref([]);
getDicts();
let view = ref('')
function getDicts() {
  commonDao.list(bizPath.dict).then((el) => {
    dics.value = el;
  });
}

if (props.temData.dictKey) {
  getOptions(props.temData.dictKey)
}

function getOptions(v) {
  dictItemDao
    .getByDictManagerCode({
      dictManagerCode: v,
    })
    .then((res) => {
      dicOptions.value = res.map((el) => ({ ...el, value: el.code }));
    });
}
</script>

<style scoped lang="scss">
.nullHypothesis {
  display: flex;
  flex-direction: column;
}
</style>
